import { render, staticRenderFns } from "./JettonTabHistorySkeletonMobile.vue?vue&type=template&id=2a99ef27&scoped=true&functional=true"
import script from "./JettonTabHistorySkeletonMobile.vue?vue&type=script&lang=js"
export * from "./JettonTabHistorySkeletonMobile.vue?vue&type=script&lang=js"
import style0 from "./JettonTabHistorySkeletonMobile.vue?vue&type=style&index=0&id=2a99ef27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2a99ef27",
  null
  
)

export default component.exports